__turbopack_context__.v({
  "background": "banner-module-scss-module__DAVqia__background",
  "banner": "banner-module-scss-module__DAVqia__banner",
  "copy": "banner-module-scss-module__DAVqia__copy",
});
